/* istanbul ignore file */
import { useMemo } from 'react';
import { LIST_PAGE_SIZE } from './List';
import { ListProvider } from './ListContext';
import useListCrud from './builder/useListCrud';
import useListDataLoading from './builder/useListDataLoading';
import useListDataUpdating from './builder/useListDataUpdating';
import useListParams from './builder/useListParams';
import { SimpleListProps } from './SimpleList';

export interface SimpleListWithSortingProps extends SimpleListProps {
  defaultSortField?: string;
  defaultSortOrder?: string;
}

const SimpleListWithSorting = ({
  getDataMethod,
  children,
  pageSize = LIST_PAGE_SIZE,
  onRemove,
  defaultSortField,
  defaultSortOrder,
}: SimpleListWithSortingProps) => {
  const {
    params: { sort },
    sortBy,
  } = useListParams({ defaultSortField, defaultSortOrder });
  const params = useMemo(
    () => ({
      sort,
    }),
    [sort],
  );

  const { loading, loadData } = useListDataLoading({ getDataMethod, pageSize });
  const { data } = useListDataUpdating({ loadData, params });
  const listCrud = useListCrud({ onRemove, inputData: data });

  const contextValue = {
    ...listCrud,
    loading,
    sortBy,
    sort,
  };

  return <ListProvider value={contextValue}>{children}</ListProvider>;
};

export default SimpleListWithSorting;
